// extracted by mini-css-extract-plugin
module.exports = {"Config":"Config__2ZY5W","Advanced":"Advanced__3t0ao"};